import requestAction from '../../utils/requestAction'
import School, { SchoolInput } from '../../models/School';

export const bulkUpsertSchools = (records: (School|SchoolInput)[]) =>
  requestAction('SCHOOL_BULK_UPSERT')('schools/bulk', 'POST', { records })
